import React from 'react';
import { useLocation } from 'react-router-dom';
import CuotasForm from '../components/tabForms/CuotasForm'
import { Container } from '@mui/material';

const CuotasPage = () => {
    const location = useLocation();
    const  formData   = location.state || {};  // Acceder a los datos del cliente

    return (
        <Container maxWidth="lg">
            {/* Pasar los datos del cliente como props al formulario */}
            {/*   <ProgressStepsComponent isAdmin={isAdmin} /> */}
            <CuotasForm 
            //customer={formData.customer } 
            contractData={formData}
            />
        </Container>
    );
};

export default CuotasPage;
